import axios, { AxiosInstance } from 'axios';

export const createAxiosInstance = (redirectUrl: string, baseURL?: string): AxiosInstance => {
    if (!baseURL) {
        throw new Error('VITE_API_URL is not defined in environment variables');
    }

    const instance = axios.create({
        baseURL,
        withCredentials: true,
        headers: {
            'Content-Type': 'application/json',
        },
    });

    instance.interceptors.response.use(
        (response) => response,
        (error) => {
            if (error.response?.status === 401) {
                window.location.href = redirectUrl;
            }

            return Promise.reject(error);
        }
    );

    return instance;
};
